<template>
        <h2
            class="homepage-title display-1 text-center tw-relative"
            :class="{ 'homepage-title--dark': dark}"
            >
            <slot></slot>
        </h2>
</template>

<script>
export default {
    props: {
        dark: Boolean
    }
}
</script>
